import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getExperts(params = {}) {
    return httpAdminClient.get('admin/experts', { params });
  },
  createExpert(data) {
    return httpAdminClient.post('admin/experts', { expert: { ...data } });
  },
  patchExpert(id, data) {
    return httpAdminClient.patch(`admin/experts/${id}`, { expert: { ...data } });
  },
  deleteExpert(id) {
    return httpAdminClient.delete(`admin/experts/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/expertsApis.js